// extracted by mini-css-extract-plugin
export default {"proj1i":"project_proj1i__9UH8h","arrow":"project_arrow__jySnB","proj":"project_proj__HKprf","projp":"project_projp__-DfIl","btncar":"project_btncar__gzlbe"};